import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import "antd/dist/antd.css";
import "./assets/css/globle/index.css";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import store, { persistor } from "./store";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./app/pages/login/authConfig";
import { ConfigProvider as ConfigProvider5 } from "antd-v5";

String.prototype.replaceAll = function (s1, s2) {
  // @ts-ignore
  return this.replace(new RegExp(s1, "gm"), s2);
};

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  // @ts-ignore
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    // @ts-ignore
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const container = document.getElementById("root");
// @ts-ignore
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider5
          prefixCls="ant5"
          theme={{
            token: {
              fontFamily: `"DIN-OT", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif`,
            },
          }}
        >
          {/* @ts-ignore */}
          <App instance={msalInstance} />
        </ConfigProvider5>
      </PersistGate>
    </MsalProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
